/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import React from "react";
import { Query } from "react-apollo";
import {
    GET_SPECIAL_INITIATIVE_DEALS_QUERY,
    GET_SPECIAL_INITIATIVE_FULL_DEALS_QUERY
} from "../../../graphql/query/DealQuery";
import { AuthorizationService } from "../../../service/AuthorizationService";
import { User } from "../../../types/mainTypes";
import DealsListingContainer from "../deals/DealListing/DealsListingContainer";

type Props = {
    user: User;
    authorizationService: AuthorizationService;
    initiative;
    first?;
    sort;
    keyword?: string;
    updateState?;
};
class SpecialInitiativeDealsListing extends React.Component<Props> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const user = this.props.user;
        const { authorizationService } = this.props;

        return (
            <Query
                query={
                    user
                        ? GET_SPECIAL_INITIATIVE_FULL_DEALS_QUERY
                        : GET_SPECIAL_INITIATIVE_DEALS_QUERY
                }
                variables={{
                    initiative: this.props.initiative,
                    first: this.props.first,
                    sort: this.props.sort
                }}
                fetchPolicy={"network-only"}
            >
                {({ loading, networkStatus, data, refetch, fetchMore }) => {
                    let deals = [];

                    let hasNextPage = false;
                    if (!loading && data && data.deals && networkStatus === 7) {
                        deals = data.deals.edges;
                        hasNextPage = data.deals.pageInfo.has_next_page;
                    }

                    return (
                        <DealsListingContainer
                            data={data}
                            // TS FOUND ERROR: no prop disableSorting
                            // @ts-ignore
                            disableSorting={true}
                            networkStatus={networkStatus}
                            loading={loading}
                            deals={deals}
                            hasNextPage={hasNextPage}
                            fetchMore={fetchMore}
                            refetch={refetch}
                            dealType={"active"}
                            authorizationService={authorizationService}
                            keyword={this.props.keyword}
                            sort={this.props.sort}
                            updateState={this.props.updateState}
                            disableFilter={true}
                        />
                    );
                }}
            </Query>
        );
    }
}

export default SpecialInitiativeDealsListing;
